import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DthComponent } from './dth/dth.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { MsgDialogComponent } from './msg-dialog/msg-dialog.component';
import { PlanComponent } from './plan/plan.component';
import { NavigationComponent } from './navigation/navigation.component';
import { PrepaidComponent } from './prepaid/prepaid.component';
import { AppService } from './app.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StatementComponent } from './statement/statement.component';
import { ElectricityComponent } from './electricity/electricity.component';
import {  RetailerComponent } from './retailer/retailer.component';

@NgModule({
  declarations: [
    AppComponent,
    DthComponent,
    FooterComponent,
    HeaderComponent,
    HomeComponent,
    LoginComponent,
    MsgDialogComponent,
    PlanComponent,
    NavigationComponent,
    PrepaidComponent,
    StatementComponent,
    ElectricityComponent,
    RetailerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule
  ],
  providers: [AppService],
  bootstrap: [AppComponent]
})
export class AppModule { }
